<template>
  <section class="section-block">
    <div class="mini-title">任务确认</div>
    <div class="plan-summary-band">
      <span>可执行子任务 {{ taskSummary.executableCount }}</span>
      <span>阻断目标 {{ taskSummary.blockedCount }}</span>
      <span>目标店铺 {{ taskSummary.storeCount }}</span>
      <span>冻结规则版本 {{ taskSummary.ruleVersions }}</span>
    </div>

    <div class="mini-title">预创建父任务</div>
    <div class="drawer-table-scroll">
      <el-table
        :data="parentTaskRows"
        border
        size="mini"
        class="precreate-parent-table"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
      >
        <el-table-column prop="taskName" label="任务名称" min-width="180" show-overflow-tooltip />
        <el-table-column prop="targetProduct" label="目标商品" min-width="110" />
        <el-table-column prop="executableCount" label="可执行子任务" min-width="110" />
        <el-table-column prop="blockedCount" label="阻断目标" min-width="90" />
        <el-table-column prop="ruleVersions" label="规则版本" min-width="300" show-overflow-tooltip />
        <el-table-column prop="afterStatus" label="创建后状态" min-width="130" />
      </el-table>
    </div>

    <div class="mini-title">
      预创建子任务
      <span class="section-note">仅下列通过预检的目标会创建并进入执行队列</span>
    </div>
    <div class="drawer-table-scroll precreate-task-scroll">
      <el-table
        :data="childTaskRows"
        border
        size="mini"
        class="precreate-child-table"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
      >
        <el-table-column prop="storeName" label="店铺" min-width="110" />
        <el-table-column prop="model" label="产品型号" min-width="100" />
        <el-table-column prop="platformSpu" label="平台商品编码" min-width="150" />
        <el-table-column prop="type" label="素材类型" min-width="130" />
        <el-table-column prop="currentVersion" label="规则版本" min-width="150" />
        <el-table-column prop="skuName" label="销售属性名称" min-width="120" />
        <el-table-column prop="outputFileNum" label="预计输出文件" min-width="110" />
        <el-table-column prop="processMode" label="处理方式" min-width="120" />
        <el-table-column prop="replacePosition" label="替换位置" min-width="120" />
      </el-table>
    </div>

    <div class="mini-title">
      不创建的阻断目标
      <span class="section-note">仅记录到父任务明细，不进入图片处理及上传队列</span>
    </div>
    <div class="drawer-table-scroll precreate-task-scroll">
      <el-table
        :data="blockedTaskRows"
        border
        size="mini"
        class="precreate-blocked-table"
        :row-class-name="blockedRowClassName"
        :header-cell-style="tableHeaderStyle"
        :cell-style="tableCellStyle"
      >
        <el-table-column prop="storeName" label="店铺" min-width="110" />
        <el-table-column prop="model" label="产品型号" min-width="100" />
        <el-table-column prop="platformSpu" label="平台商品编码" min-width="150" />
        <el-table-column prop="type" label="素材类型" min-width="130" />
        <el-table-column prop="conclusion" label="阻断原因" min-width="300" show-overflow-tooltip />
        <el-table-column prop="checkStatus" label="校验状态" min-width="100">
          <template slot-scope="{ row }">
            <span class="status-danger">{{ row.checkStatus }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </section>
</template>

<script>
const mockChildTaskRows = [
  {
    groupName: '淘系',
    storeName: '天猫一店',
    model: 'DW1207',
    platformSpu: '1067936616677',
    type: '主图',
    currentVersion: 'TAO20260818001',
    skuName: '',
    outputFileNum: 1,
    processMode: '等比缩放',
    replacePosition: '主图对应分类'
  },
  {
    groupName: '淘系',
    storeName: '天猫一店',
    model: 'DW1207',
    platformSpu: '1067936616677',
    type: '竖版主图',
    currentVersion: 'TAO20260818001',
    skuName: '',
    outputFileNum: 1,
    processMode: '等比缩放',
    replacePosition: '主图对应分类'
  },
  {
    groupName: '淘系',
    storeName: '天猫一店',
    model: 'DW1207',
    platformSpu: '1067936616677',
    type: '销售属性图',
    currentVersion: 'TAO20260818001',
    skuName: '6个',
    outputFileNum: 1,
    processMode: '等比缩放',
    replacePosition: '对应分类'
  },
  {
    groupName: '淘系',
    storeName: '天猫一店',
    model: 'DW1207',
    platformSpu: '1067936616677',
    type: '透明图',
    currentVersion: 'TAO20260818001',
    skuName: '',
    outputFileNum: 1,
    processMode: '等比缩放',
    replacePosition: '对应分类'
  },
  {
    groupName: '淘系',
    storeName: '天猫一店',
    model: 'DW1207',
    platformSpu: '1067936616677',
    type: '详情页',
    currentVersion: 'TAO20260818001',
    skuName: '',
    outputFileNum: 5,
    processMode: '切分',
    replacePosition: '详情页'
  }
]

export default {
  name: 'StoreGoodsImageStepThree',
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    },
    precheckData: {
      type: Object,
      default: () => ({})
    },
    planRows: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    taskSummary () {
      const storeNames = Array.from(new Set(this.planRows.map(item => item.storeName).filter(Boolean)))
      const versions = Array.from(new Set(this.planRows.map(item => item.currentVersion).filter(Boolean)))
      return {
        executableCount: this.childTaskRows.length,
        blockedCount: this.blockedTaskRows.length,
        storeCount: storeNames.length,
        ruleVersions: versions.join('、') || '-'
      }
    },
    parentTaskRows () {
      return [
        {
          taskName: '本次店铺商品图片替换',
          targetProduct: this.productModel,
          executableCount: this.taskSummary.executableCount,
          blockedCount: this.taskSummary.blockedCount,
          ruleVersions: this.taskSummary.ruleVersions,
          afterStatus: '创建后自动执行'
        }
      ]
    },
    childTaskRows () {
      return mockChildTaskRows
    },
    blockedTaskRows () {
      return this.planRows.filter(item => item.checkStatus === 'BLOCKED')
    },
    productModel () {
      return this.rowData.productModel || '122717'
    }
  },
  methods: {
    async handleCreateTask () {
      try {
        const res = await this.$q.newProduct.imageProcessingTasks({
          data: {
            confirmedSoftExceptionKeys: [],
            precheckId: this.precheckData.precheckId || 0
          }
        })
        const response = res && res.data
        if (response && response.success === false) {
          this.$message.error(response.message || '任务创建失败')
          return null
        }
        const taskResult = response && response.data ? response.data : response
        this.$message.success(response && response.message ? response.message : '任务创建成功')
        this.$emit('task-created', taskResult)
        return taskResult
      } catch (error) {
        const response = error && error.response && error.response.data
        this.$message.error(response && response.message ? response.message : '任务创建失败')
        return null
      }
    },
    tableHeaderStyle () {
      return { backgroundColor: '#FAFAFA', textAlign: 'center' }
    },
    tableCellStyle () {
      return { textAlign: 'center' }
    },
    blockedRowClassName () {
      return 'highlight-row'
    }
  }
}
</script>

<style lang="stylus" scoped>
.section-block
  margin-bottom 16px

.mini-title
  font-size 14px
  font-weight 600
  color #303133
  margin-bottom 10px

.section-note
  color #909399
  font-size 12px
  font-weight 400
  margin-left 8px

.plan-summary-band
  display flex
  flex-wrap wrap
  gap 12px
  margin-bottom 12px
  padding 10px 12px
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  color #303133
  font-size 13px

.drawer-table-scroll
  overflow-x auto
  margin-bottom 12px

.precreate-parent-table
  min-width 760px

.precreate-child-table
  min-width 1080px

.precreate-blocked-table
  min-width 920px

.status-danger
  color #f56c6c

>>> .highlight-row td
  background-color #fff1f0 !important

>>> .el-table__body-wrapper
  overflow-y auto
</style>
